import './App.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages/Home.js";
import ContactForm from "./pages/ContactForm.js";
import Contact from "./pages/Contact.js";
import ProchainesTournees from "./pages/ProchainesTournees.js";
import MentionsLegales from "./pages/MentionsLegales.js";
import StickyNavbar from './components/Global/StickyNavbar.js';
import Footer from './components/Global/Footer.js';
function App() {
  return (
	<Router>
		<StickyNavbar />
		<Routes>
			<Route exact path="/" element={<Home />} />
			<Route path="/ContactForm" element={<ContactForm />} />
			<Route path="/MentionsLegales" element={<MentionsLegales />} />
			<Route path="/Contact" element={<Contact />} />
			<Route path="/ProchainesTournees" element={<ProchainesTournees />} />
		</Routes>
		<Footer />
	</Router>
  );
}

export default App;
